import { PracticeReserveInstructorModel } from '../../../models/practice/reserve/instructor/PracticeReserveInstructor';

// 日本語可能な講師(ランダム)
//   講師一覧の先頭に足す疑似講師（API を取ったときに親で足す）
export const jaRandomInstructor = {
  inst_id: 'ja',
  name: '日本語可能な講師(ランダム)',
  image_file: '/images/page/practice/noimage_random.png',
  schedule_count: 0,
  open_term_flg: {
    term_15: true,
    term_30: true,
    term_45: true
  },
  gender: '',
  hometown: '',
  is_ja: '',
  hobby: '',
} as PracticeReserveInstructorModel;
